import { StudyContextData, SubmissionContextData } from "@/context/AppContext";

import { SecondaryButton } from "@shared/components/Button";

import { UploadErrorAlert } from "@/components/submission/Alerts";
import { StudyFileUploadHelp } from "@/components/help/StudyHelp";

interface UploadErrorFlowProps {
  studyContext: StudyContextData;
  submissionContext: SubmissionContextData;
}

export function UploadErrorFlow({ studyContext, submissionContext }: UploadErrorFlowProps) {
  const { writeState, resetValidation } = submissionContext;
  const { study } = studyContext;

  if (writeState.status !== "upload_error" || !study) {
    return null;
  }

  return (
    <div>
      <UploadErrorAlert message={writeState.message}>
        <div className="-mt-2">
          <SecondaryButton variant="secondary" round highlight onClick={resetValidation}>
            Try another file
          </SecondaryButton>
        </div>
      </UploadErrorAlert>
      <div className="mt-4 pt-4 border-t border-neutral-200 dark:border-neutral-800">
        <StudyFileUploadHelp studyId={study.id} />
      </div>
    </div>
  );
}
